import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';

import { useAxiosConfig } from '#/shared/hooks/useAxiosConfig';
import { useTimesheetStore } from '#/shared/stores/timesheetStore';

// TODO: PPL-2240-verify-timesheet-action cleanup - Remove this default url as API will return the correct url
const DEFAULT_RESET_VERIFICATION_URL = '/timesheet-online-approval/reset-verification';

const resetVerificationRequest = async ({ api, url }: { api: AxiosInstance; url: string }) => {
  return api.patch(url);
};

export const useResetVerificationTimesheetMutation = () => {
  const api = useAxiosConfig();
  const url = useTimesheetStore(state => state.links?.resetVerification?.href ?? DEFAULT_RESET_VERIFICATION_URL);

  return useMutation<AxiosResponse, AxiosError>({
    mutationFn: () => resetVerificationRequest({ api, url }),
    onSuccess: () => {
      const { resetVerification } = useTimesheetStore.getState();
      // We reset the verifiedBy data to undefined rather than invalidating. Invalidating the query would re-render paidbreak exceptions progress.
      resetVerification();
    },
  });
};
